"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefType = void 0;
const prop_types_1 = __importDefault(require("prop-types"));
exports.RefType = prop_types_1.default.oneOfType([
    prop_types_1.default.string,
    prop_types_1.default.func,
    prop_types_1.default.shape({
        current: prop_types_1.default.oneOfType([prop_types_1.default.elementType, prop_types_1.default.object])
    })
]);
